import React, { useState } from "react";
import { Grid, Typography } from "@mui/material";
export function PageNotFound() {
  return (
    <Grid container>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",

          alignContent: "center",

          height: "100vh",
          margin: 0,
          fontSize: "1.2em",
        }}
      >
        <Grid item xs={12}>
          <Typography variant="h5"> Oops! Page is not Found</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
